"use client";
import { useApp } from "@/forApp/states/appState/appState";
import ArchiveObjectModal from "@/widgets/Modals/ArchiveObjectModal/ArchiveObjectModal";
import AuthModal from "@/widgets/Modals/AuthModal/AuthModal";
import ConsultationModal from "@/widgets/Modals/ConsultationModal/ConsultationModal";
import DeleteAgentModal from "@/widgets/Modals/DeleteAgentModal/DeleteAgentModal";
import DeleteObjectModal from "@/widgets/Modals/DeleteObjectModal/DeleteObjectModal";
import OtherMainFilterModal from "@/widgets/Modals/OtherMainFilter/OtherMainFilterModal";
import PasswordChangeModal from "@/widgets/Modals/PasswordChangeModal/PasswordChangeModal";

const ModalsWrapper = () => {
	const { modals } = useApp();

	if (!modals.length) {
		return null;
	}
	return (
		<>
			{modals[0].name === "ConsultationModal" ? (
				<ConsultationModal title={modals[0].title} from={modals[0].from} />
			) : null}
			{modals[0].name === "AuthModal" ? (
				<AuthModal type={modals[0].type} />
			) : null}
			{modals[0].name === "PasswordChangeModal" ? (
				<PasswordChangeModal />
			) : null}
			{modals[0].name === "DeleteAgentModal" ? (
				<DeleteAgentModal
					agent={modals[0].agent}
					onConfirm={modals[0].onConfirm}
				/>
			) : null}
			{modals[0].name === "ArchiveObjectModal" ? (
				<ArchiveObjectModal
					object={modals[0].object}
					mutate={modals[0].mutate}
				/>
			) : null}
			{modals[0].name === "DeleteObjectModal" ? (
				<DeleteObjectModal
					object={modals[0].object}
					mutate={modals[0].mutate}
				/>
			) : null}
			{modals[0].name === "OtherFiltersModal" ? (
				<OtherMainFilterModal
					allowFilters={modals[0].allowFilters}
					moreFilter={modals[0].moreFilter}
				/>
			) : null}
		</>
	);
};

export default ModalsWrapper;
